import { trackAddProductToQuickOrderGrid } from "@DSG/Common/DSGTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain,DispatchCompleteAddProduct } from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainAfter(chain,DispatchCompleteAddProduct, addQuickOrderToGridTracking);

// get the type of props using this
type TrackingParameters = Parameters<typeof DispatchCompleteAddProduct>[0];


function addQuickOrderToGridTracking(props: TrackingParameters) {
    const state = props.getState();
    if (state.pages && state.context) {
            trackAddProductToQuickOrderGrid(props.parameter.product);
        }
    }
